const N = Symbol.for("constructDateFrom");
function y(e, t) {
  return typeof e == "function" ? e(t) : e && typeof e == "object" && N in e ? e[N](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
function l(e, t) {
  return y(t || e, e);
}
let J = {};
function x() {
  return J;
}
function W(e, t) {
  var c, o, d, h;
  const n = x(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((o = (c = t == null ? void 0 : t.locale) == null ? void 0 : c.options) == null ? void 0 : o.weekStartsOn) ?? n.weekStartsOn ?? ((h = (d = n.locale) == null ? void 0 : d.options) == null ? void 0 : h.weekStartsOn) ?? 0, a = l(e, t == null ? void 0 : t.in), i = a.getDay(), u = (i < r ? 7 : 0) + i - r;
  return a.setDate(a.getDate() - u), a.setHours(0, 0, 0, 0), a;
}
function E(e, t) {
  return W(e, { ...t, weekStartsOn: 1 });
}
function j(e, t) {
  const n = l(e, t == null ? void 0 : t.in), r = n.getFullYear(), a = y(n, 0);
  a.setFullYear(r + 1, 0, 4), a.setHours(0, 0, 0, 0);
  const i = E(a), u = y(n, 0);
  u.setFullYear(r, 0, 4), u.setHours(0, 0, 0, 0);
  const c = E(u);
  return n.getTime() >= i.getTime() ? r + 1 : n.getTime() >= c.getTime() ? r : r - 1;
}
function q(e) {
  const t = l(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function U(e, ...t) {
  const n = y.bind(
    null,
    t.find((r) => typeof r == "object")
  );
  return t.map(n);
}
function H(e, t) {
  const n = l(e, t == null ? void 0 : t.in);
  return n.setHours(0, 0, 0, 0), n;
}
function z(e, t, n) {
  const [r, a] = U(
    n == null ? void 0 : n.in,
    e,
    t
  ), i = H(r), u = H(a), c = +i - q(i), o = +u - q(u);
  return Math.round((c - o) / 864e5);
}
function K(e, t) {
  const n = j(e, t), r = y(e, 0);
  return r.setFullYear(n, 0, 4), r.setHours(0, 0, 0, 0), E(r);
}
function Z(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function p(e) {
  return !(!Z(e) && typeof e != "number" || isNaN(+l(e)));
}
function ee(e, t) {
  const n = l(e, t == null ? void 0 : t.in);
  return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
const te = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, ne = (e, t, n) => {
  let r;
  const a = te[e];
  return typeof a == "string" ? r = a : t === 1 ? r = a.one : r = a.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function Y(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const re = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, ae = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, ie = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, ue = {
  date: Y({
    formats: re,
    defaultWidth: "full"
  }),
  time: Y({
    formats: ae,
    defaultWidth: "full"
  }),
  dateTime: Y({
    formats: ie,
    defaultWidth: "full"
  })
}, se = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, ce = (e, t, n, r) => se[e];
function T(e) {
  return (t, n) => {
    const r = n != null && n.context ? String(n.context) : "standalone";
    let a;
    if (r === "formatting" && e.formattingValues) {
      const u = e.defaultFormattingWidth || e.defaultWidth, c = n != null && n.width ? String(n.width) : u;
      a = e.formattingValues[c] || e.formattingValues[u];
    } else {
      const u = e.defaultWidth, c = n != null && n.width ? String(n.width) : e.defaultWidth;
      a = e.values[c] || e.values[u];
    }
    const i = e.argumentCallback ? e.argumentCallback(t) : t;
    return a[i];
  };
}
const oe = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, de = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, fe = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, he = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, me = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, le = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, ge = (e, t) => {
  const n = Number(e), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, we = {
  ordinalNumber: ge,
  era: T({
    values: oe,
    defaultWidth: "wide"
  }),
  quarter: T({
    values: de,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: T({
    values: fe,
    defaultWidth: "wide"
  }),
  day: T({
    values: he,
    defaultWidth: "wide"
  }),
  dayPeriod: T({
    values: me,
    defaultWidth: "wide",
    formattingValues: le,
    defaultFormattingWidth: "wide"
  })
};
function k(e) {
  return (t, n = {}) => {
    const r = n.width, a = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], i = t.match(a);
    if (!i)
      return null;
    const u = i[0], c = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], o = Array.isArray(c) ? be(c, (g) => g.test(u)) : (
      // [TODO] -- I challenge you to fix the type
      ye(c, (g) => g.test(u))
    );
    let d;
    d = e.valueCallback ? e.valueCallback(o) : o, d = n.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      n.valueCallback(d)
    ) : d;
    const h = t.slice(u.length);
    return { value: d, rest: h };
  };
}
function ye(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function be(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function Me(e) {
  return (t, n = {}) => {
    const r = t.match(e.matchPattern);
    if (!r) return null;
    const a = r[0], i = t.match(e.parsePattern);
    if (!i) return null;
    let u = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    u = n.valueCallback ? n.valueCallback(u) : u;
    const c = t.slice(a.length);
    return { value: u, rest: c };
  };
}
const De = /^(\d+)(th|st|nd|rd)?/i, Oe = /\d+/i, Pe = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Te = {
  any: [/^b/i, /^(a|c)/i]
}, ke = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, We = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Ee = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, xe = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, ve = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Ye = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Se = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, _e = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Fe = {
  ordinalNumber: Me({
    matchPattern: De,
    parsePattern: Oe,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: k({
    matchPatterns: Pe,
    defaultMatchWidth: "wide",
    parsePatterns: Te,
    defaultParseWidth: "any"
  }),
  quarter: k({
    matchPatterns: ke,
    defaultMatchWidth: "wide",
    parsePatterns: We,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: k({
    matchPatterns: Ee,
    defaultMatchWidth: "wide",
    parsePatterns: xe,
    defaultParseWidth: "any"
  }),
  day: k({
    matchPatterns: ve,
    defaultMatchWidth: "wide",
    parsePatterns: Ye,
    defaultParseWidth: "any"
  }),
  dayPeriod: k({
    matchPatterns: Se,
    defaultMatchWidth: "any",
    parsePatterns: _e,
    defaultParseWidth: "any"
  })
}, Ae = {
  code: "en-US",
  formatDistance: ne,
  formatLong: ue,
  formatRelative: ce,
  localize: we,
  match: Fe,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function Ce(e, t) {
  const n = l(e, t == null ? void 0 : t.in);
  return z(n, ee(n)) + 1;
}
function Ne(e, t) {
  const n = l(e, t == null ? void 0 : t.in), r = +E(n) - +K(n);
  return Math.round(r / 6048e5) + 1;
}
function B(e, t) {
  var h, g, O, P;
  const n = l(e, t == null ? void 0 : t.in), r = n.getFullYear(), a = x(), i = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((g = (h = t == null ? void 0 : t.locale) == null ? void 0 : h.options) == null ? void 0 : g.firstWeekContainsDate) ?? a.firstWeekContainsDate ?? ((P = (O = a.locale) == null ? void 0 : O.options) == null ? void 0 : P.firstWeekContainsDate) ?? 1, u = y((t == null ? void 0 : t.in) || e, 0);
  u.setFullYear(r + 1, 0, i), u.setHours(0, 0, 0, 0);
  const c = W(u, t), o = y((t == null ? void 0 : t.in) || e, 0);
  o.setFullYear(r, 0, i), o.setHours(0, 0, 0, 0);
  const d = W(o, t);
  return +n >= +c ? r + 1 : +n >= +d ? r : r - 1;
}
function qe(e, t) {
  var c, o, d, h;
  const n = x(), r = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((o = (c = t == null ? void 0 : t.locale) == null ? void 0 : c.options) == null ? void 0 : o.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((h = (d = n.locale) == null ? void 0 : d.options) == null ? void 0 : h.firstWeekContainsDate) ?? 1, a = B(e, t), i = y((t == null ? void 0 : t.in) || e, 0);
  return i.setFullYear(a, 0, r), i.setHours(0, 0, 0, 0), W(i, t);
}
function He(e, t) {
  const n = l(e, t == null ? void 0 : t.in), r = +W(n, t) - +qe(n, t);
  return Math.round(r / 6048e5) + 1;
}
function s(e, t) {
  const n = e < 0 ? "-" : "", r = Math.abs(e).toString().padStart(t, "0");
  return n + r;
}
const w = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), r = n > 0 ? n : 1 - n;
    return s(t === "yy" ? r % 100 : r, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : s(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return s(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return s(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return s(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return s(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return s(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, r = e.getMilliseconds(), a = Math.trunc(
      r * Math.pow(10, n - 3)
    );
    return s(a, t.length);
  }
}, D = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, I = {
  // Era
  G: function(e, t, n) {
    const r = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const r = e.getFullYear(), a = r > 0 ? r : 1 - r;
      return n.ordinalNumber(a, { unit: "year" });
    }
    return w.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, r) {
    const a = B(e, r), i = a > 0 ? a : 1 - a;
    if (t === "YY") {
      const u = i % 100;
      return s(u, 2);
    }
    return t === "Yo" ? n.ordinalNumber(i, { unit: "year" }) : s(i, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = j(e);
    return s(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return s(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "Q":
        return String(r);
      // 01, 02, 03, 04
      case "QQ":
        return s(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "q":
        return String(r);
      // 01, 02, 03, 04
      case "qq":
        return s(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return w.M(e, t);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      // 1, 2, ..., 12
      case "L":
        return String(r + 1);
      // 01, 02, ..., 12
      case "LL":
        return s(r + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, r) {
    const a = He(e, r);
    return t === "wo" ? n.ordinalNumber(a, { unit: "week" }) : s(a, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const r = Ne(e);
    return t === "Io" ? n.ordinalNumber(r, { unit: "week" }) : s(r, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : w.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const r = Ce(e);
    return t === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : s(r, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const r = e.getDay();
    switch (t) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, r) {
    const a = e.getDay(), i = (a - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(i);
      // Padded numerical value
      case "ee":
        return s(i, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return n.ordinalNumber(i, { unit: "day" });
      case "eee":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, r) {
    const a = e.getDay(), i = (a - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (same as in `e`)
      case "c":
        return String(i);
      // Padded numerical value
      case "cc":
        return s(i, t.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return n.ordinalNumber(i, { unit: "day" });
      case "ccc":
        return n.day(a, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return n.day(a, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return n.day(a, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return n.day(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const r = e.getDay(), a = r === 0 ? 7 : r;
    switch (t) {
      // 2
      case "i":
        return String(a);
      // 02
      case "ii":
        return s(a, t.length);
      // 2nd
      case "io":
        return n.ordinalNumber(a, { unit: "day" });
      // Tue
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const a = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const r = e.getHours();
    let a;
    switch (r === 12 ? a = D.noon : r === 0 ? a = D.midnight : a = r / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const r = e.getHours();
    let a;
    switch (r >= 17 ? a = D.evening : r >= 12 ? a = D.afternoon : r >= 4 ? a = D.morning : a = D.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let r = e.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return w.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : w.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const r = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : s(r, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let r = e.getHours();
    return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : s(r, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : w.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : w.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return w.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const r = e.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (t) {
      // Hours and optional minutes
      case "X":
        return Q(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return b(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return b(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Hours and optional minutes
      case "x":
        return Q(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return b(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return b(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + R(r, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + b(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + R(r, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + b(r, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const r = Math.trunc(+e / 1e3);
    return s(r, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    return s(+e, t.length);
  }
};
function R(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), a = Math.trunc(r / 60), i = r % 60;
  return i === 0 ? n + String(a) : n + String(a) + t + s(i, 2);
}
function Q(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + s(Math.abs(e) / 60, 2) : b(e, t);
}
function b(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), a = s(Math.trunc(r / 60), 2), i = s(r % 60, 2);
  return n + a + t + i;
}
const X = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, V = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, Ie = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], r = n[1], a = n[2];
  if (!a)
    return X(e, t);
  let i;
  switch (r) {
    case "P":
      i = t.dateTime({ width: "short" });
      break;
    case "PP":
      i = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      i = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      i = t.dateTime({ width: "full" });
      break;
  }
  return i.replace("{{date}}", X(r, t)).replace("{{time}}", V(a, t));
}, Re = {
  p: V,
  P: Ie
}, Qe = /^D+$/, Xe = /^Y+$/, $e = ["D", "DD", "YY", "YYYY"];
function Ge(e) {
  return Qe.test(e);
}
function Le(e) {
  return Xe.test(e);
}
function je(e, t, n) {
  const r = Be(e, t, n);
  if (console.warn(r), $e.includes(e)) throw new RangeError(r);
}
function Be(e, t, n) {
  const r = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const Ve = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Je = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Ue = /^'([^]*?)'?$/, ze = /''/g, Ke = /[a-zA-Z]/;
function Ze(e, t, n) {
  var h, g, O, P, _, F, A, C;
  const r = x(), a = (n == null ? void 0 : n.locale) ?? r.locale ?? Ae, i = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((g = (h = n == null ? void 0 : n.locale) == null ? void 0 : h.options) == null ? void 0 : g.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((P = (O = r.locale) == null ? void 0 : O.options) == null ? void 0 : P.firstWeekContainsDate) ?? 1, u = (n == null ? void 0 : n.weekStartsOn) ?? ((F = (_ = n == null ? void 0 : n.locale) == null ? void 0 : _.options) == null ? void 0 : F.weekStartsOn) ?? r.weekStartsOn ?? ((C = (A = r.locale) == null ? void 0 : A.options) == null ? void 0 : C.weekStartsOn) ?? 0, c = l(e, n == null ? void 0 : n.in);
  if (!p(c))
    throw new RangeError("Invalid time value");
  let o = t.match(Je).map((m) => {
    const f = m[0];
    if (f === "p" || f === "P") {
      const v = Re[f];
      return v(m, a.formatLong);
    }
    return m;
  }).join("").match(Ve).map((m) => {
    if (m === "''")
      return { isToken: !1, value: "'" };
    const f = m[0];
    if (f === "'")
      return { isToken: !1, value: pe(m) };
    if (I[f])
      return { isToken: !0, value: m };
    if (f.match(Ke))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + f + "`"
      );
    return { isToken: !1, value: m };
  });
  a.localize.preprocessor && (o = a.localize.preprocessor(c, o));
  const d = {
    firstWeekContainsDate: i,
    weekStartsOn: u,
    locale: a
  };
  return o.map((m) => {
    if (!m.isToken) return m.value;
    const f = m.value;
    (!(n != null && n.useAdditionalWeekYearTokens) && Le(f) || !(n != null && n.useAdditionalDayOfYearTokens) && Ge(f)) && je(f, t, String(e));
    const v = I[f[0]];
    return v(c, f, a.localize, d);
  }).join("");
}
function pe(e) {
  const t = e.match(Ue);
  return t ? t[1].replace(ze, "'") : e;
}
function et(e) {
  return Math.trunc(+l(e) / 1e3);
}
const tt = "MMMM d", $ = "MMMM d, y", it = "MMMM dd, y", ut = "MM/dd/yyyy", G = "E, MM/dd/yyyy", st = "EEEE, MMM d", nt = "h:mm", rt = "h:mmaaa", S = (e) => et(new Date(e)) > 0, ct = (e, t) => typeof window > "u" || !e || !S(e) ? null : new Date(new Date(e).getTime() - t * 60 * 1e3), ot = (e, t, n) => {
  if (!e || !S(e))
    return null;
  const r = new Date(e);
  let a = r.getHours(), i = r.getMinutes();
  const u = a >= 12 ? n : t;
  return a %= 12, a = a === 0 ? 12 : a, i = i < 10 ? `0${i}` : i, `${a}:${i}${u}`;
}, dt = (e, t, n) => {
  if (!e || e.length < 4)
    return null;
  let r = 0;
  parseInt(e.slice(0, 2), 10) < 10 ? (r = parseInt(e.slice(1), 10), r === 0 && (r = 12)) : parseInt(e.slice(0, 2), 10) > 12 ? r = parseInt(e.slice(0, 2), 10) - 12 : r = parseInt(e.slice(0, 2), 10);
  const a = e.slice(-2), i = parseInt(e.slice(0, 2), 10) >= 12 ? n : t;
  return `${r}:${a}${i}`;
};
function M(e, t, n) {
  return !e || !S(e) ? null : Ze(new Date(e), t, n);
}
const L = (e) => M(e, rt) || "", at = (e) => M(e, nt) || "", ft = (e, t) => {
  const n = M(e, $), r = M(t, $);
  return n === r ? `${n}` : `${M(e, tt)} - ${r}`;
}, ht = (e, t) => {
  const n = L(t);
  return n ? `${at(e)} - ${n}` : L(e);
}, mt = (e, t, n) => {
  const r = M(t, G), a = M(n, G);
  return r === a ? e : a ? `${r} - ${a}` : r || "";
};
export {
  tt as DATE_MONTH_DAY_FORMAT,
  $ as DATE_MONTH_DAY_YEAR_FORMAT,
  ut as DATE_MONTH_DAY_YEAR_TWO_DIGIT,
  G as DATE_MONTH_DAY_YEAR_WEEK_TWO_DIGIT,
  it as DATE_MONTH_ZERO_DAY_YEAR_FORMAT,
  rt as DATE_TIME_MINUTES_AM_FORMAT,
  nt as DATE_TIME_MINUTES_FORMAT,
  st as DATE_WEEK_DAY_MONTH_THREE_DIGITS_DAY,
  ft as formatEventStartAndEndDates,
  mt as formatEventStartAndEndDatesWithWeek,
  ht as formatEventStartAndEndTime,
  at as formatEventTime,
  L as formatEventTimeWithAMFormat,
  dt as formatTime,
  M as getFormattedDate,
  ot as getFormattedTime,
  ct as getZonedDate,
  S as isValidDate
};
